import { render, staticRenderFns } from "./OxygenAlignInput.vue?vue&type=template&id=6388cead&"
import script from "./OxygenAlignInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenAlignInput.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenAlignInput.vue?vue&type=style&index=0&id=6388cead&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports